import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import resources from './translation';

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  nsSeparator: '',
  interpolation: {
    escapeValue: false,
    skipOnVariables: false,
  },
});

export { i18n };
